import { useQuery } from '@tanstack/react-query';
import { useField } from 'formik';
import { TextField } from 'src/components/TextField';
import { fetchAllLifecycleStages } from 'src/models/lifecycle/lifecycle';

interface LifecycleStageSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

interface FormLifecycleStageSelectProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const LifecycleStageSelect: React.FC<LifecycleStageSelectProps> = ({
  value,
  onChange,
  label = 'Lifecycle Stage',
  placeholder = 'Select Lifecycle Stage',
  disabled = false,
  error,
  helperText,
}) => {
  const { data: lifecycleStages, isLoading } = useQuery({
    queryKey: ['lifecycleStages'],
    queryFn: fetchAllLifecycleStages,
    staleTime: 60000,
    gcTime: 60000,
  });

  const options = [
    { value: '', label: placeholder, disabled: true },
    ...(lifecycleStages || []).map((stage) => ({
      value: stage.id.toString(),
      label: stage.name,
    })),
  ];

  return (
    <TextField
      label={label}
      error={error}
      helperText={helperText}
      disabled={isLoading || disabled}
      options={options}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export const FormLifecycleStageSelect: React.FC<
  FormLifecycleStageSelectProps
> = ({ name, label, placeholder, disabled }) => {
  const [field, meta] = useField({ name });

  return (
    <LifecycleStageSelect
      value={field.value || ''}
      onChange={(value) => field.onChange({ target: { name, value } })}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched ? meta.error : undefined}
    />
  );
};
